import { Segmented } from "antd";
import "./MobileFilterContainer.scss";
import { useState } from "react";
import { ReactComponent as CheckMark } from "../../assets/img/smallCheckIcon.svg";
import { ReactComponent as RightArrow } from "../../assets/img/rightArrow.svg";
import CustomMobileDateRange from "../CustomMobileDateRange/CustomMobileDateRange";
import Button from "../UIKits/Button/Button";


interface FilterSelectionType {
  [key: string]: {label: string, value: string | Date[] | number};
}


interface MobileFilterContainerType {
  setShowFilterBottomSheet: (showOtherFilterBottomSheet: boolean) => void;
  customizedOptionAction?: () => void;
  optionsData: {
    type: string;
    options: { label: string; value: string | number | Date[] }[];
  }[];
  applyFilterAction: (selectedOption: FilterSelectionType) => void;
}

const MobileFilterContainer = ({
  setShowFilterBottomSheet,
  optionsData,
  customizedOptionAction,
  applyFilterAction,
}: MobileFilterContainerType) => {
  const [visibleOption, setVisibleOption] = useState(optionsData[0].type);
  const [filterSelection, setFilterSelection] = useState<FilterSelectionType>(
    {}
  );
  const [showCustomDateFilter, setShowCustomDateFilter] = useState(false);

  const handleSelectChange = (
    type: string,
    option: { label: string; value: string | number | Date[] }
  ) => {
    if (option.label !== "Custom") {
      setFilterSelection((prevState) => ({
        ...prevState,
        [type]: { label: option.label, value: option.value },
      }));
    } else if (option.label === "Custom" && type === "date") {
      setShowCustomDateFilter(true);
    } else {
      if (customizedOptionAction) {
        customizedOptionAction();
      }
    }
  };

  const applySelectedFilterOptions = () => {
    applyFilterAction(filterSelection);
    setShowFilterBottomSheet(false);
  };

  const clearAllSelectedOptions = () => {
    setFilterSelection({});
    setShowCustomDateFilter(false);
  };

  const setDateValue = (dateValue: Date[]) => {
    setFilterSelection((prevState: any) => ({
      ...prevState,
      date: { label: "Custom", value: [dateValue[0], dateValue[1]] },
    }));
  };

  return (
    <div className="mobile-filter-container">
      {showCustomDateFilter ? (
        <CustomMobileDateRange setDateValue={setDateValue} />
      ) : (
        <>
          <Segmented<string>
            options={optionsData.map((option) => `${option.type}`)}
            onChange={(value) => {
              setVisibleOption(value);
            }}
          />
          <div className="option-container">
            {optionsData.map(
              (optionGroup) =>
                optionGroup.type === visibleOption && (
                  <div key={optionGroup.type}>
                    {optionGroup.options.map((option, id) => (
                      <p
                        key={id}
                        className={`option ${
                          filterSelection[visibleOption]?.label === option.label
                            ? "selected"
                            : ""
                        }`}
                        onClick={() =>
                          handleSelectChange(visibleOption, option)
                        }>
                        {option.label}{" "}
                        <span>
                          {option.label === "Custom" ? (
                            <RightArrow className="custom-arrow" />
                          ) : (
                            filterSelection[visibleOption]?.label ===
                              option.label && <CheckMark />
                          )}
                        </span>
                      </p>
                    ))}
                  </div>
                )
            )}
          </div>
        </>
      )}

      <div className="button-container">
        <Button
           
          className="w-full font-medium !px-2.5 md:px-3.5 !py-1.5 text-nowrap text-sm"
          onClick={clearAllSelectedOptions}
        >Clear all </Button>
        <Button
           
          className={`w-full font-medium !px-2.5 md:px-3.5 !py-1.5 text-nowrap text-sm`}
          disabled={
            filterSelection &&
            !filterSelection?.date?.value &&
            showCustomDateFilter
          }
          onClick={applySelectedFilterOptions}
        >Apply</Button>
      </div>
    </div>
  );
};

export default MobileFilterContainer;
